import React, { useEffect } from "react";
import { HiMagnifyingGlass } from "react-icons/hi2";
import { useNavigate, useLocation } from "react-router-dom";
import mahiLogo from "../../../assets/images/mahi-download-logo.png";
import { AdminSearchProvider, useAdminSearch } from "./admin-search-context";

interface AdminLayoutProps {
  children: React.ReactNode;
}

const AdminLayoutInner: React.FC<AdminLayoutProps> = ({ children }) => {
  const { searchQuery, setSearchQuery } = useAdminSearch();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const isHome = pathname === "/admin/home";

  useEffect(() => {
    // admin 페이지 진입 시 root 요소의 max-width 제한 해제
    const rootElement = document.getElementById("root");
    if (rootElement) {
      rootElement.style.maxWidth = "none";
      rootElement.style.boxShadow = "none";
    }

    // cleanup 함수: 컴포넌트 언마운트 시 원래 스타일로 복원
    return () => {
      if (rootElement) {
        rootElement.style.maxWidth = "742px";
        rootElement.style.boxShadow = "0 0 10px rgba(0, 0, 0, 0.1)";
      }
    };
  }, []);

  return (
    <div className="min-h-screen bg-gray-100">
      {/* 글로벌 상단 바 */}
      <header className="sticky top-0 z-50 border-b border-gray-200 bg-white shadow-sm">
        <div
          className={`mx-auto grid h-16 grid-cols-3 items-center gap-4 px-2 md:px-6 ${isHome ? "max-w-6xl" : ""}`}
        >
          <button
            type="button"
            onClick={() => navigate("/admin/home")}
            className="flex shrink-0 items-center gap-2"
          >
            <img
              src={mahiLogo}
              alt="마감히어로"
              className="h-10 w-auto object-contain pt-0.5"
            />
            <span className="text-[1.75rem] font-semibold text-gray-600">
              Admin
            </span>
          </button>
          {isHome && (
            <div className="relative flex justify-center">
              <div className="relative w-full max-w-md">
                <HiMagnifyingGlass className="absolute left-3 top-1/2 h-5 w-5 -translate-y-1/2 text-gray-400" />
                <input
                  type="search"
                  placeholder="메뉴 검색..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  className="w-full rounded-xl border border-gray-200 bg-gray-50 py-2 pl-10 pr-4 text-sm text-gray-800 placeholder-gray-400 transition focus:border-blue-500 focus:bg-white focus:outline-none focus:ring-2 focus:ring-blue-500/20"
                />
              </div>
            </div>
          )}
          <div className="flex shrink-0" />
        </div>
      </header>

      {/* 메인 콘텐츠 영역 */}
      <main className="p-4">{children}</main>
    </div>
  );
};

const AdminLayout: React.FC<AdminLayoutProps> = ({ children }) => (
  <AdminSearchProvider>
    <AdminLayoutInner>{children}</AdminLayoutInner>
  </AdminSearchProvider>
);

export default AdminLayout;
